import * as Constants from "../Constants";
import { getAPIIncludeAuth } from "./Shared";

export function getAllAllergyTypes() {
    const api = Constants.BACKEND_URL + Constants.API_ALLERGY_TYPE + "?paginationEnabled=false";
    return getAPIIncludeAuth(api);
}
